export const CostCategorySummaryGridData = [
  {
    no: 1,
    account: '141-01-1001',
    category: 'Survey, Title, ROW',
    description: 'ROW Lease Fees',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 2,
    account: '141-01-1001',
    category: 'Survey, Title, ROW',
    description: 'Access fees (roads)',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 3,
    account: '141-01-1001',
    category: 'Survey, Title, ROW',
    description: 'Temporary Sites (bores, construction)',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 4,
    account: '141-01-1003',
    category: 'Survey, Title, ROW',
    description: 'ROW Agent Fees',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 5,
    account: '141-01-1003',
    category: 'Survey, Title, ROW',
    description: 'Title Agent Fees',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 6,
    account: '141-01-1004',
    category: 'Survey, Title, ROW',
    description: 'Preliminary Survey',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 7,
    account: '141-01-1004',
    category: 'Survey, Title, ROW',
    description: 'Plats, Alignment Sheets',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 8,
    account: '141-01-1004',
    category: 'Survey, Title, ROW',
    description: 'As-Built Survey',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 9,
    account: '141-01-1004',
    category: 'Survey, Title, ROW',
    description: 'Biological Survey',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 10,
    account: '141-01-1004',
    category: 'Survey, Title, ROW',
    description: 'Archeological Survey',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 11,
    account: '141-01-1004',
    category: 'Survey, Title, ROW',
    description: 'Class Location/HCA Study',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 12,
    account: '141-01-1004',
    category: 'Survey, Title, ROW',
    description: 'SWPPP Services',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 13,
    account: '141-01-1007',
    category: 'Survey, Title, ROW',
    description: 'Misc Permits and Fees',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 14,
    account: '',
    category: '',
    description: 'Survey, Title, ROW Total',
    isSummary: true,
  },
  {
    no: 15,
    account: '141-01-2001',
    category: 'Materials',
    description: 'Line Pipe',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 16,
    account: '141-01-2001',
    category: 'Materials',
    description: 'Heavy Wall Pipe',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 17,
    account: '141-01-2002',
    category: 'Materials',
    description: 'Segmentable Elbows',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 18,
    account: '141-01-2002',
    category: 'Materials',
    description: 'Mainline Valves',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 19,
    account: '141-01-2002',
    category: 'Materials',
    description: 'Tap Valves',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 20,
    account: '141-01-2002',
    category: 'Materials',
    description: 'Launcher/Receiver Set',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 21,
    account: '141-01-2022',
    category: 'Materials',
    description: 'Cathodic Protection',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 22,
    account: '141-01-2022',
    category: 'Materials',
    description: 'Corrosion Program (Chem Pumps, Coupons)',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 23,
    account: '141-01-2023',
    category: 'Materials',
    description: 'Flow/Pressure Control',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 24,
    account: '141-01-2023',
    category: 'Materials',
    description: 'Water (Hydrotest)',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 25,
    account: '141-01-2041',
    category: 'Materials',
    description: 'Pipeline Markers',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 26,
    account: '141-01-2041',
    category: 'Materials',
    description: 'Line Fill',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 27,
    account: '141-01-2051',
    category: 'Materials',
    description: 'Tarrifs',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 28,
    account: '141-01-2052',
    category: 'Materials',
    description: 'Freight',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 29,
    account: '',
    category: '',
    description: 'Materials Total',
    isSummary: true,
  },
  {
    no: 30,
    account: '141-01-3003',
    category: 'Construction',
    description: 'Mainline Lay Price',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 31,
    account: '141-01-3003',
    category: 'Construction',
    description: 'Bore Construction',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 32,
    account: '141-01-3003',
    category: 'Construction',
    description: 'Direct Pipe',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 33,
    account: '141-01-3003',
    category: 'Construction',
    description: 'Horizontal Directional Drill',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 34,
    account: '141-01-3003',
    category: 'Construction',
    description: 'Rock Ditch with Trencher',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 35,
    account: '141-01-3003',
    category: 'Construction',
    description: 'Install Trap',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 36,
    account: '141-01-3003',
    category: 'Construction',
    description: 'Mainline Valve',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 37,
    account: '141-01-3003',
    category: 'Construction',
    description: 'Tap Valves',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 38,
    account: '141-01-3003',
    category: 'Construction',
    description: 'Fabrication Launcher',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 39,
    account: '141-01-3003',
    category: 'Construction',
    description: 'Foreign Line Crossing',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 40,
    account: '141-01-3003',
    category: 'Construction',
    description: 'Construction Mats',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 41,
    account: '141-01-3003',
    category: 'Construction',
    description: 'Hot Tap',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 42,
    account: '141-01-3003',
    category: 'Construction',
    description: 'Heavy Timber Clearing',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 43,
    account: '141-01-3003',
    category: 'Construction',
    description: 'Open Cut Wetlands & Waterbodies',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 44,
    account: '141-01-3013',
    category: 'Construction',
    description: 'NDE',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 45,
    account: '141-01-3013',
    category: 'Construction',
    description: 'Chemical Treatment',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 46,
    account: '141-01-3013',
    category: 'Construction',
    description: 'Pipeline Drying',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 47,
    account: '141-01-4002',
    category: 'Construction',
    description: 'Capitalized Salaries',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 48,
    account: '141-01-4003',
    category: 'Construction',
    description: 'Capitalized Travel',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 49,
    account: '141-01-4006',
    category: 'Construction',
    description: 'Engineering Services',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 50,
    account: '',
    category: '',
    description: 'Construction Total',
    isSummary: true,
  },
  {
    no: 51,
    account: '141-01-4001',
    category: 'Project Management',
    description: 'Inspection Services',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 52,
    account: '141-01-4004',
    category: 'Project Management',
    description: 'Environmental Services',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 53,
    account: '141-01-6002',
    category: 'Project Management',
    description: 'Legal Fees Services',
    pmOverride: '',
    price: '',
    contingencyPercent: '0%',
    costOverridePercent: '0%',
    contingency: '0%',
    contingencyCost: '$',
    taxRate: 'n/a',
    taxCost: 'n/a',
    baseCost: '$',
    totalPrice: '$',
  },
  {
    no: 54,
    account: '',
    category: '',
    description: 'Project Management Total',
    isSummary: true,
  },
  {
    no: 55,
    account: '',
    category: '',
    description: 'Total Project',
    isSummary: true,
  },
];
